export default __webpack_public_path__ + "static/Poppins-MediumItalic-89e040c6a64d18f620dc8547b01b6291.ttf";